import { axiosInstance } from './Api';

export const fetchManufacturerDashboard = async () => {
    try {
        const { data } = await axiosInstance.get('/manufacturer/dashboard');
        return data;
    } catch (error) {
        console.error('Error fetching manufacturer dashboard data:', error);
        throw error;
    }
};

export const fetchManufacturerProducts = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/products', { params });
    return data;
};

export const createManufacturerProduct = async (payload) => {
    const { data } = await axiosInstance.post('/manufacturer/products', payload);
    return data;
};

export const fetchManufacturerProduct = async (id) => {
    const { data } = await axiosInstance.get(`/manufacturer/products/${id}`);
    return data;
};

export const fetchManufacturerProductInsights = async (id, params = {}) => {
    const { data } = await axiosInstance.get(`/manufacturer/products/${id}/insights`, { params });
    return data;
};

export const fetchManufacturerProductTransactions = async (id, params = {}) => {
    const { data } = await axiosInstance.get(`/manufacturer/products/${id}/transactions`, { params });
    return data;
};

export const fetchManufacturerTransactions = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/transactions', { params });
    return data;
};

export const fetchManufacturerRetailers = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/retailers', { params });
    return data;
};

export const fetchManufacturerRetailerDetail = async (retailerId) => {
    const { data } = await axiosInstance.get(`/manufacturer/retailers/${retailerId}`);
    return data;
};

export const fetchManufacturerRetailersGraph = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/retailers/graph', { params });
    return data;
};

export const fetchManufacturerRetailerVenues = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/retailers/venues', { params });
    return data;
};

export const fetchManufacturerDistributors = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/distributors', { params });
    return data;
};

export const fetchManufacturerDistributorStats = async () => {
    const { data } = await axiosInstance.get('/manufacturer/distributors/stats');
    return data;
};

export const fetchManufacturerDistributorDetail = async (distributorId) => {
    const { data } = await axiosInstance.get(`/manufacturer/distributors/${distributorId}`);
    return data;
};

export const fetchManufacturerVenues = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/venues', { params });
    return data;
};

export const fetchManufacturerVenue = async (venueId) => {
    const { data } = await axiosInstance.get(`/manufacturer/venues/${venueId}`);
    return data;
};

export const createManufacturerVenue = async (payload) => {
    const { data } = await axiosInstance.post('/manufacturer/venues', payload);
    return data;
};

export const fetchManufacturerTransactionStats = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/analytics/transactions/stats', { params });
    return data;
};

export const fetchManufacturerTransactionDemographics = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/analytics/transactions/demographics', { params });
    return data;
};

export const fetchManufacturerTransactionProgress = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/analytics/transactions/progress', { params });
    return data;
};

export const fetchManufacturerWarrantyStats = async () => {
    const { data } = await axiosInstance.get('/manufacturer/warranties/stats');
    return data;
};

export const fetchManufacturerWarrantyTemplates = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/warranties/templates', { params });
    return data;
};

export const fetchManufacturerWarrantyTemplate = async (id) => {
    const { data } = await axiosInstance.get(`/manufacturer/warranties/templates/${id}`);
    return data;
};

export const createManufacturerWarrantyTemplate = async (payload) => {
    const { data } = await axiosInstance.post('/manufacturer/warranties/templates', payload);
    return data;
};

export const updateManufacturerWarrantyTemplate = async (id, payload) => {
    const { data } = await axiosInstance.put(`/manufacturer/warranties/templates/${id}`, payload);
    return data;
};

export const deleteManufacturerWarrantyTemplate = async (id) => {
    const { data } = await axiosInstance.delete(`/manufacturer/warranties/templates/${id}`);
    return data;
};

export const fetchManufacturerWarrantyTypes = async () => {
    const { data } = await axiosInstance.get('/manufacturer/warranties/types');
    return data;
};

export const fetchManufacturerWarrantyCategories = async () => {
    const { data } = await axiosInstance.get('/manufacturer/warranties/categories');
    return data;
};

export const fetchManufacturerWarrantyItems = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/warranties/items', { params });
    return data;
};

export const fetchManufacturerActiveWarranties = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/warranties/active', { params });
    return data;
};

export const fetchManufacturerSupportStats = async () => {
    const { data } = await axiosInstance.get('/manufacturer/support/claims/stats');
    return data;
};

export const fetchManufacturerSupportClaims = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/support/claims', { params });
    return data;
};

export const updateManufacturerSupportClaim = async (id, payload) => {
    const { data } = await axiosInstance.put(`/manufacturer/support/claims/${id}`, payload);
    return data;
};

export const fetchManufacturerSettings = async () => {
    const { data } = await axiosInstance.get('/manufacturer/settings');
    return data;
};

export const updateManufacturerSettings = async (payload) => {
    const { data } = await axiosInstance.put('/manufacturer/settings', payload);
    return data;
};

export const regenerateManufacturerApiToken = async () => {
    const { data } = await axiosInstance.post('/manufacturer/settings/api-token');
    return data;
};

export const fetchManufacturerIntegrations = async () => {
    const { data } = await axiosInstance.get('/manufacturer/integrations');
    return data;
};

export const createManufacturerIntegration = async (payload) => {
    const { data } = await axiosInstance.post('/manufacturer/integrations', payload);
    return data;
};

export const fetchManufacturerIntegration = async (id) => {
    const { data } = await axiosInstance.get(`/manufacturer/integrations/${id}`);
    return data;
};

export const updateManufacturerIntegration = async (id, payload) => {
    const { data } = await axiosInstance.put(`/manufacturer/integrations/${id}`, payload);
    return data;
};

export const deleteManufacturerIntegration = async (id) => {
    const { data } = await axiosInstance.delete(`/manufacturer/integrations/${id}`);
    return data;
};

export const rotateManufacturerIntegrationCredentials = async (id) => {
    const { data } = await axiosInstance.post(`/manufacturer/integrations/${id}/rotate-credentials`);
    return data;
};

export const pingManufacturerIntegrationWebhook = async (id) => {
    const { data } = await axiosInstance.post(`/manufacturer/integrations/${id}/webhook-test`);
    return data;
};

export const fetchManufacturerImports = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/imports', { params });
    return data;
};

export const createManufacturerImport = async (payload) => {
    const { data } = await axiosInstance.post('/manufacturer/imports', payload);
    return data;
};

export const fetchManufacturerExports = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/exports', { params });
    return data;
};

export const createManufacturerExport = async (payload) => {
    const { data } = await axiosInstance.post('/manufacturer/exports', payload);
    return data;
};

export const fetchManufacturerComplianceDocs = async (params = {}) => {
    const { data } = await axiosInstance.get('/manufacturer/compliance', { params });
    return data;
};

export const createManufacturerComplianceDoc = async (payload) => {
    const { data } = await axiosInstance.post('/manufacturer/compliance', payload);
    return data;
};

export const updateManufacturerComplianceDoc = async (id, payload) => {
    const { data } = await axiosInstance.put(`/manufacturer/compliance/${id}`, payload);
    return data;
};

export const shareManufacturerComplianceDoc = async (id, payload) => {
    const { data } = await axiosInstance.post(`/manufacturer/compliance/${id}/share`, payload);
    return data;
};

export const deleteManufacturerComplianceDoc = async (id) => {
    const { data } = await axiosInstance.delete(`/manufacturer/compliance/${id}`);
    return data;
};
